import { ReactNode } from "react";
import { htmlToMarkdown } from "./htmlToMarkdown";
import { markdownFormatter } from "./markdownFormatter";

/**
 * Formats an HTML string value for DataTable cells by converting to markdown
 * and rendering through the markdown formatter.
 *
 * Supported HTML: strong, b, em, i, code, mark, ul, ol, li, br, p.
 * Unsupported tags and their content are dropped entirely.
 * HTML entities are decoded to plain text.
 *
 * @param value - The HTML string to format
 * @returns Formatted React nodes, or null for empty/null/undefined values
 */
export const htmlFormatter = (value?: string | null): ReactNode => {
  const markdown = htmlToMarkdown(value);
  return markdownFormatter(markdown);
};
